module.exports = __webpack_public_path__ + "img/2023_JMB.9e1a0160.png";